import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@ochal/utils';

/** Shared presentation slots. Callers retain all data, event and permission ownership. */
export function PanelHeader({ title, description, action, className, ...props }: Omit<HTMLAttributes<HTMLElement>, 'title'> & { title: ReactNode; description?: ReactNode; action?: ReactNode }) {
  return <header className={cn('ui-panel-header', className)} {...props}><div><h2>{title}</h2>{description && <p>{description}</p>}</div>{action}</header>;
}
export function PanelBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('ui-panel-body', className)} {...props}/>;
}
export function PanelFooter({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <footer className={cn('ui-panel-footer', className)} {...props}/>;
}
export function FilterBar({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('ui-filter-bar', className)} {...props}/>;
}
export function ActionBar({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('ui-action-bar', className)} {...props}/>;
}
export function FieldGroup({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('ui-field-group', className)} {...props}/>;
}
/** Receives already calculated values. It must never infer deltas, targets or units. */
export function KpiCard({ label, value, unit, context, icon, children, className, ...props }: HTMLAttributes<HTMLElement> & { label: ReactNode; value: ReactNode; unit?: ReactNode; context?: ReactNode; icon?: ReactNode }) {
  return <article className={cn('ui-card ui-kpi-card', className)} {...props}><div className="ui-kpi-label"><span>{label}</span>{icon}</div><div className="ui-kpi-value">{value}{unit && <small>{unit}</small>}</div>{context && <div className="ui-kpi-context">{context}</div>}{children}</article>;
}
export function ChartFrame({ title, description, action, children, className, ...props }: Omit<HTMLAttributes<HTMLElement>, 'title'> & { title: ReactNode; description?: ReactNode; action?: ReactNode }) {
  return <section className={cn('ui-card ui-chart-frame', className)} {...props}><PanelHeader title={title} description={description} action={action}/><PanelBody>{children}</PanelBody></section>;
}
